import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { ContrastButton } from './ContrastButton';
import { CriticalButton } from './CriticalButton';
import { PrimaryButton } from './PrimaryButton';
import { SecondaryButton } from './SecondaryButton';
import { TextButton } from './TextButton';
const ButtonComponent = (props, ref) => {
    switch (props.variant) {
        case 'primary':
            return _jsx(PrimaryButton, Object.assign({}, props, { ref: ref }));
        case 'secondary':
            return _jsx(SecondaryButton, Object.assign({}, props, { ref: ref }));
        case 'text':
            return _jsx(TextButton, Object.assign({}, props, { ref: ref }));
        case 'critical':
            return _jsx(CriticalButton, Object.assign({}, props, { ref: ref }));
        case 'contrast':
            return _jsx(ContrastButton, Object.assign({}, props, { ref: ref }));
        default:
            return _jsx(PrimaryButton, Object.assign({}, props, { ref: ref }));
    }
};
export const Button = forwardRef(ButtonComponent);
